import React from "react";
import Seo from "../components/Seo";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <Seo title="Terms of Service" description="Terms and conditions for using Rooted in Amador." path="/terms" />
      <div className="text-xs tracking-wider-2 uppercase text-sage mb-3">Legal</div>
      <h1 className="font-display text-5xl text-darkRoast mb-12">Terms of Service</h1>
      <div className="text-earth space-y-8 leading-relaxed">

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">1. Overview</h2>
          <p>These terms govern your use of rootedinamador.com and any purchases made through our store. By placing an order you agree to these terms. We're a small family business in Plymouth, California, and we'll always treat you fairly and expect the same in return.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">2. Products</h2>
          <p>All seeds sold by Rooted in Amador are naturally sourced and non-GMO. We do not use the term "certified organic" because we are not a certified organic operation, though our seeds are sourced from an organic supplier. Germination rates vary by variety, growing conditions, and seed storage, so we cannot guarantee specific germination outcomes.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">3. Orders & payment</h2>
          <p>All prices are listed in US dollars. Payment is processed securely by Stripe. We reserve the right to cancel any order due to stock unavailability, pricing errors, or suspected fraud, in which case a full refund will be issued promptly.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">4. Shipping & pickup</h2>
          <p>See our <a href="/shipping" className="text-darkRoast underline hover:text-sage">Shipping & Pickup page</a> for rates, timelines, and local pickup details. Risk of loss passes to you upon handoff to USPS or completion of local pickup.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">5. Returns & refunds</h2>
          <p>See our <a href="/returns" className="text-darkRoast underline hover:text-sage">Returns & Refunds page</a> for our full policy. We stand behind everything we sell.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">6. Intellectual property</h2>
          <p>All content on this site, including text, photos, logos, and grow guides, is owned by Rooted in Amador and may not be reproduced without written permission.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">7. Limitation of liability</h2>
          <p>Rooted in Amador is not liable for crop failures, losses, or damages resulting from the use of our seeds. Our liability in any case is limited to the purchase price of the products involved.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">8. Governing law</h2>
          <p>These terms are governed by the laws of the State of California. Any disputes shall be resolved in Amador County, California.</p>
        </section>

        <section>
          <h2 className="font-display text-2xl text-darkRoast mb-3">9. Contact</h2>
          <p>Questions about these terms? Email <a href="mailto:hello@rootedinamador.com" className="text-darkRoast underline hover:text-sage">hello@rootedinamador.com</a>.</p>
          <p className="text-sm text-earth/70 mt-4">Last updated: June 2026</p>
        </section>

      </div>
    </div>
  );
}
